'use strict';

/**
 *
 * @category   View
 * @module     collection
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Cengiz Mardin <cm@humans.am>
 */

var ColidoLayoutView = require('base/Colido.LayoutView');
var Util = require('base/Colido.Util');
var ColidoCollection = require('base/Colido.Collection');
var RestrictionModalView = require('modules/base/views/layout/restriction-print-modal');

var template = require('modules/base/templates/layout/advanced-print-modal.hbs');

var AdvancedPrintModalView = ColidoLayoutView.extend({
    template: template,

    ui: {
        actionClose: '[data-action="close"]',
        form: 'form',
        itemsPerPage: '[name="itemsPerPage"]',
        title: '[name="title"]',
        reportType: '[name="reportType"]',
        tableList: '.table-columns',
        tableListItem: '.table-columns input[type="checkbox"]',
        tableColumnsRegion: '.table-columns-region',
    },

    events: {
        'click @ui.tableColumnsRegion': 'tableColumnsRegionRestriction',
        'click @ui.actionClose': 'actionClose',
        'click @ui.tableListItem': 'onTableListItem',
        'submit @ui.form': 'onFormSubmit',
        'change @ui.reportType': 'onReportTypeChange',
    },

    restricted: false,

    viewData: {
        printFields: function() {
            return this.getOption('catalog').getPrintFields();
        },
    },

    initialize: function(options) {
        ColidoLayoutView.prototype.initialize.apply(this, arguments);

        if (_.isUndefined(options.collection)) {
            options.collection = new ColidoCollection(options.item);
            this.collection = options.collection;
        }
    },

    onReportTypeChange: function() {
        if (this.ui.reportType.filter(':checked').val() === 'detailed') {
            this.ui.tableColumnsRegion.stop().slideDown();
        } else {
            this.ui.tableColumnsRegion.stop().slideUp();
        }
    },

    actionClose: function (event) {
        this.trigger('close:modal');
    },

    tableColumnsRegionRestriction: function() {
        if (this.restricted == true) {
            var restrictionModalView = new RestrictionModalView();
            var options = {
                additionalClassName: 'modal-center modal-restriction',
            };
            App.addModal(restrictionModalView, options);
        }
    },

    onRender: function () {
        var collection = this.getOption('collection');

        if (collection.setModel) {
            this.ui.title.val(collection.setModel.get('name'));
        }

        if (!App.user.get('licenseAdvancedLabelPrint')) {
            this.ui.tableColumnsRegion.addClass('row-restricted');
            this.restricted = true;
        }
    },

    onFormSubmit: function(event) {
        var collection = this.getOption('collection');
        var items = collection.pluck('id');

        App.radio('collection').execute('print:report', {
            format: 'pdf',
            title: this.ui.title.val(),
            catalogId: this.getOption('catalog').id,
            printSummery: this.$('input[name=printSummery]:checked').val(),
            reportType: App.user.get('licenseAdvancedLabelPrint') ? 'advanced' : 'simple',
            itemsPerPage: this.$('input[name=itemsPerPage]:checked').val(),
            pageSize: this.$('input[name=pageSize]:checked').val(),
            columns: this.ui.tableListItem.filter(':checked').map(function(i, e){
                return $(e).val();
            }).toArray(),
            items: items,
            set: collection.setModel ? collection.setModel.get('id') : null,
        });

        this.trigger('close:modal');

        event.preventDefault();
    },
});

module.exports = AdvancedPrintModalView;